export const CREATE_NEW_PROJECT = "CREATE_NEW_PROJECT";
export const DELETE_PROJECT = "DELETE_PROJECT";
export const SET_ALL_PROJECTS = "SET_ALL_PROJECTS";

// NEW: save snapshot into a project
export const SAVE_PROJECT_SNAPSHOT = "SAVE_PROJECT_SNAPSHOT";

export const _onCreateImageAnalysisProject = (data) => {
  return (dispatch) => {
    dispatch({
      type: CREATE_NEW_PROJECT,
      payload: data,
    });
  };
};
export const _onDeleteImageAnalysisProject = (id) => {
  return (dispatch) => {
    dispatch({
      type: DELETE_PROJECT,
      payload: id,
    });
  };
};

// call this with your built snapshot
export const _onSaveProjectSnapshot = ({ projectId, snapshot }) => ({
  type: SAVE_PROJECT_SNAPSHOT,
  payload: { projectId, snapshot },
});

export const _onSetAllAnalysisProjects = (data) => {
  return (dispatch) => {
    dispatch({
      type: "SET_ALL_PROJECTS",
      payload: data,
    });
  };
};
